import {
  FETCH_PROJECTS_REQUEST,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_FAILURE,
  CREATE_PROJECT_REQUEST,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  UPDATE_PROJECT_REQUEST,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  DELETE_PROJECT_REQUEST,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAILURE,
  ASSIGN_USERS_TO_PROJECT_REQUEST,
  ASSIGN_USERS_TO_PROJECT_SUCCESS,
  ASSIGN_USERS_TO_PROJECT_FAILURE,
  FETCH_PROJECT_TEAMS_REQUEST,
  FETCH_PROJECT_TEAMS_SUCCESS,
  FETCH_PROJECT_TEAMS_FAILURE,
  REMOVE_PROJECT_TEAMS_REQUEST,
  REMOVE_PROJECT_TEAMS_SUCCESS,
  REMOVE_PROJECT_TEAMS_FAILURE,
} from '../actions/projectActions';

const initialState = {
  projects: [],
  teams: [],
  loading: false,
  error: null,
};

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROJECTS_REQUEST:
    case CREATE_PROJECT_REQUEST:
    case UPDATE_PROJECT_REQUEST:
    case DELETE_PROJECT_REQUEST:
    case ASSIGN_USERS_TO_PROJECT_REQUEST:
    case FETCH_PROJECT_TEAMS_REQUEST:
    case REMOVE_PROJECT_TEAMS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PROJECTS_SUCCESS:
      return { ...state, loading: false, projects: action.payload };

    case CREATE_PROJECT_SUCCESS:
      return { ...state, loading: false, projects: [...state.projects, action.payload] };

    case UPDATE_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        projects: state.projects.map((project) =>
          project.id === action.payload.id ? action.payload : project
        ),
      };

    case DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        projects: state.projects.filter((project) => project.id !== action.payload),
      };

    case ASSIGN_USERS_TO_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        projects: state.projects.map((project) =>
          project.id === action.payload.projectId
            ? { ...project, teams: [...project.teams, ...action.payload.newTeams] }
            : project
        ),
      };

    case REMOVE_PROJECT_TEAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        projects: state.projects.map((project) =>
          project.id === action.payload.projectId
            ? { ...project, teams: project.teams.filter(team => team.id !== action.payload.teamId) }
            : project
        ),
      };

    case FETCH_PROJECTS_SUCCESS:
      return {
          ...state,
          loading: false,
          projects: action.payload, // Payload now contains `data` and `meta`
      };
      

    case FETCH_PROJECTS_FAILURE:
    case CREATE_PROJECT_FAILURE:
    case UPDATE_PROJECT_FAILURE:
    case DELETE_PROJECT_FAILURE:
    case ASSIGN_USERS_TO_PROJECT_FAILURE:
    case FETCH_PROJECT_TEAMS_FAILURE:
    case REMOVE_PROJECT_TEAMS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default projectReducer;
